export const plainLineIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.77316 18.9241L1.67856 19.0008C1.44566 19.1546 1.12886 19.1292 0.923806 18.9241C0.718962 18.719 0.693278 18.4022 0.847157 18.1693L0.924496 18.0754L18.076 0.923954C18.3102 0.690008 18.6897 0.690008 18.924 0.923954C19.1582 1.15818 19.1587 1.53828 18.9246 1.77262L1.77316 18.9241Z"
      fill="#1E1E1E"
    />
  </svg>
);

export const straightLineWithArrowIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.22678 18.4241L2.13218 18.5007C1.89928 18.6546 1.5825 18.6292 1.37743 18.4241C1.17257 18.219 1.14687 17.9022 1.30078 17.6693L1.37812 17.5754L17.4089 1.54468C17.6431 1.31074 18.0226 1.31074 18.2568 1.54468C18.4911 1.7789 18.4916 2.15901 18.2575 2.39335L2.22678 18.4241Z"
      fill="#1E1E1E"
    />
    <path
      d="M14.6454 1.51449C14.6499 1.22456 14.8587 0.98603 15.133 0.934357L15.254 0.924498L18.8726 0.980085L18.864 1.5801L18.8164 4.59943L18.8027 4.72007C18.7425 4.99243 18.4975 5.19381 18.2077 5.18942C17.8764 5.18426 17.6119 4.91141 17.6171 4.58008L17.654 2.16142L15.2353 2.12312L15.1147 2.1095C14.8422 2.04933 14.6408 1.80442 14.6454 1.51449Z"
      fill="#1E1E1E"
    />
  </svg>
);

export const elbowLineWithArrowIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.9097 3.19849V4.39771H12.0923V3.19849H17.9097Z" fill="#1E1E1E" />
    <path
      d="M8.94495 15.968L8.94495 5.84888C8.94495 4.38503 10.1315 3.19866 11.5953 3.19849L14.6774 3.19849L14.6774 4.39771L11.5953 4.39771C10.7943 4.39788 10.1451 5.04777 10.1451 5.84888L10.1451 15.968C10.1451 17.4319 8.95771 18.6184 7.49377 18.6184L1.74963 18.6184C1.4183 18.6184 1.15009 18.3501 1.15002 18.0188C1.15002 17.6874 1.41826 17.4182 1.74963 17.4182L7.49377 17.4182C8.29497 17.4182 8.94491 16.7692 8.94495 15.968Z"
      fill="#1E1E1E"
    />
    <path
      d="M15.6371 1.42908C15.8421 1.22405 16.1581 1.19814 16.391 1.35194L16.4847 1.42908L18.849 3.79237L18.4242 4.21619L16.4847 6.15565L16.391 6.2328C16.1582 6.38633 15.8421 6.36035 15.6371 6.15565C15.4028 5.92133 15.4028 5.54133 15.6371 5.30701L17.1508 3.79139L15.6371 2.27674L15.5599 2.18299C15.4061 1.9501 15.4321 1.63412 15.6371 1.42908Z"
      fill="#1E1E1E"
    />
  </svg>
);

export const curvedLineWithArrowIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.6146 3.52234L18.7357 3.53406C19.0092 3.58996 19.2152 3.83196 19.2152 4.12195C19.2152 4.41194 19.0092 4.65394 18.7357 4.70984L18.6146 4.72156H15.3236C14.6843 4.72165 14.0385 4.93728 13.4398 5.3739C12.9138 5.75756 12.4382 6.30312 12.0521 6.98425L11.892 7.28406L8.00232 15.0643C7.52006 16.0292 6.86858 16.839 6.08826 17.4081C5.40314 17.9077 4.63645 18.2079 3.84021 18.2753L3.49744 18.2899H1.17517C0.8439 18.2899 0.575724 18.0215 0.575562 17.6903C0.575562 17.3589 0.8438 17.0897 1.17517 17.0897H3.49744L3.73767 17.08C4.29767 17.0327 4.85739 16.8204 5.38123 16.4384C5.9825 15.9999 6.51811 15.3495 6.92908 14.5272L10.8187 6.74792L11.0072 6.39343C11.4657 5.58428 12.05 4.90215 12.7328 4.40417C13.5157 3.83321 14.4052 3.52244 15.3236 3.52234H18.6146Z"
      fill="#1E1E1E"
    />
    <path
      d="M16.2897 1.57618C16.4947 1.37114 16.8107 1.34524 17.0436 1.49903L17.1373 1.57618L19.6735 4.11134L19.2487 4.53516L17.1373 6.64649C16.9031 6.88033 16.5239 6.88033 16.2897 6.64649C16.0554 6.41218 16.0554 6.03217 16.2897 5.79786L17.9752 4.11036L16.2897 2.42384L16.2125 2.33009C16.0587 2.09719 16.0846 1.78121 16.2897 1.57618Z"
      fill="#1E1E1E"
    />
  </svg>
);
